import { render } from "./home.vue?vue&type=template&id=1c682b1c&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=1c682b1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c682b1c"

export default script